import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './registrationProcess.css';

const RegistrationProcess = () => {
    const [rows, setRows] = useState([{ id: 1, step_no: '', process: '' }]);

    const addRow = () => {
        setRows([...rows, { id: rows.length + 1, step_no: '', process: '' }]);
    };

    const handleChange = (id, field, value) => {
        const updatedRows = rows.map(row =>
            row.id === id ? { ...row, [field]: value } : row
        );
        setRows(updatedRows);
    };

    const save = async () => {
        // Basic validation
        for (const row of rows) {
            if (!row.step_no || !row.process) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Missing fields',
                    text: 'Please fill in all fields before submitting.',
                });
                return;
            }
        }

        try {
            const data = rows.map(row => ({
                step_no: parseInt(row.step_no), // ensure number
                process: row.process,
            }));

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/registration-process`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Registration process updated successfully!',
            });
        } catch (error) {
            console.error('Error saving data:', error);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Error saving data!',
            });
        }
    };

    return (
        <div className="registration-form">
            <h2 className="form-title mb-4 text-center">Registration Process</h2>
            {rows.map((row, index) => (
                <div key={row.id} className="form-row d-flex align-items-center mb-3">
                    <label className="form-label text-dark ms-3 me-2"><strong>Step No:</strong></label>
                    <input
                        type='number'
                        required
                        value={row.step_no}
                        onChange={e => handleChange(row.id, 'step_no', e.target.value)}
                        className="form-control step-no-input"
                    />

                    <label className="form-label text-dark ms-3 me-2"><strong>Process:</strong></label>
                    <input
                        type='text'
                        required
                        value={row.process}
                        onChange={e => handleChange(row.id, 'process', e.target.value)}
                        className="form-control process-input"
                    />
                </div>
            ))}
            <button className="btn btn-primary mt-3 me-2" onClick={addRow}>Add More</button>
            <button className="btn btn-success mt-3" onClick={save}>Update</button>
        </div>
    );
};

export default RegistrationProcess;
